const PortfolioPhoto = ({ img, alt }) => {
  return <img src={img} alt={alt} />;
};

export default PortfolioPhoto;
